import { CrudState } from "@/store/Crud/State";
import { IStudentCategory } from "@/interfaces/IStudentCategory";

export class State extends CrudState {
  filteredStudentCategories: IStudentCategory[] = [];
}
